import React from 'react';

import { Button } from '@/shared/components/ui/button/button';
import { IconBgButton } from '@/shared/components/ui/button/icon-bg-button/icon-bg-button';
import { IconButton } from '@/shared/components/ui/button/icon-button/icon-button';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';
import { TTriggerProps } from '@/shared/components/ui/trigger/trigger.types';

export const Trigger: React.FC<TTriggerProps> = ({
  component = 'Button',
  label,
  icon,
  buttonVariant = 'primary',
  menuItemVariant = 'default',
  buttonSize = 'extraSmall',
  tooltip,
  ...rest
}) => {
  const getIconButtonTooltip = () => {
    if (!tooltip || tooltip === '') {
      return label;
    }
    return tooltip;
  };

  if (component === 'Button') {
    return (
      <Button
        icon={icon}
        variant={buttonVariant}
        size={buttonSize}
        tooltip={tooltip}
        {...rest}
      >
        {label}
      </Button>
    );
  }

  if (component === 'Icon') {
    return icon;
  }

  if (component === 'IconBgButton')
    return (
      <IconBgButton
        variant={buttonVariant}
        size={buttonSize}
        tooltip={getIconButtonTooltip()}
        {...rest}
      >
        {icon}
      </IconBgButton>
    );

  if (component === 'IconButton')
    return (
      <IconButton tooltip={getIconButtonTooltip()} {...rest}>
        {icon}
      </IconButton>
    );

  return (
    <MenuItem icon={icon} variant={menuItemVariant} tooltip={tooltip} {...rest}>
      {label}
    </MenuItem>
  );
};
